import ImpressionEvent, { type ImpressionType } from './ImpressionEvent';
import type {
  SocialEmbedPlacement,
  SocialEmbedProvider
} from './SocialEmbedInteractionEvent';

export type SocialEmbedImpressionProperties = {
  embed_url: string;
  module_position?: number;
  module_type?: 'embed';
  placement: SocialEmbedPlacement;
  provider: SocialEmbedProvider;
};

type EventData = {
  embedUrl: string;
  guestId?: string;
  isBot: boolean;
  modulePosition?: number;
  moduleType?: 'embed';
  placement: SocialEmbedPlacement;
  provider: SocialEmbedProvider;
};

class SocialEmbedImpressionEvent extends ImpressionEvent<
  EventData,
  SocialEmbedImpressionProperties
> {
  protected get impressionType(): ImpressionType {
    return 'social_embed';
  }

  protected getImpressionProperties(): SocialEmbedImpressionProperties {
    return {
      embed_url: this.data.embedUrl,
      module_position: this.data.modulePosition,
      module_type: this.data.moduleType,
      placement: this.data.placement,
      provider: this.data.provider
    };
  }
}

export default SocialEmbedImpressionEvent;
